module.exports = __webpack_public_path__ + "img/warning1.254788b0.png";